import { a as __rest } from '../../tslib.es6.esm.js';
import { jsx } from 'react/jsx-runtime';
import { Separator } from '@radix-ui/react-separator';
import { dividerStyles } from './Divider.styles.esm.js';
import { cn } from '../../utils/cn.esm.js';

/**
 *  The Divider component is a visual separator, as a horizontal or vertical line that groups and divides content.
 */
const Divider = (_a) => {
    var { className, inverse, orientation = "horizontal" } = _a, props = __rest(_a, ["className", "inverse", "orientation"]);
    const classes = dividerStyles({ inverse, orientation });
    return (jsx(Separator, Object.assign({ className: cn(classes, className), decorative: true }, props)));
};
Divider.displayName = "Divider";

export { Divider };
